import $ from 'jquery';

$.confirm = function (element, message, noAbort, callback) {
  if (typeof noAbort === 'function') {
    callback = noAbort;
    noAbort = message;
    message = element;
    element = null;
  }

  $.dim();

  $('#modal-panel').remove();

  var html = ['<div class="dialog"><p></p>'];
  if (noAbort) {
    html.push('<button class="borderless confirm">Ok</button>');
  } else {
    html.push('<button class="cancel">Abbrechen</button>');
    html.push('<button class="confirm">Ja, ich bin sicher.</button>');
  }
  html.push('</div>');

  const dialog = $(html.join(''))
    .prependTo('body')
    .find('p')
    .text(message)
    .end()
    .find('.cancel')
    .on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      $.undim();
      dialog.removeClass('visible');
      setTimeout(() => {
        dialog.remove();
      }, 1000);

      return false;
    })
    .end()
    .find('.confirm')
    .on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      $.undim();

      dialog.removeClass('visible');
      setTimeout(() => {
        dialog.remove();
      }, 1000);

      if (callback) {
        callback();
      } else if (element) {
        location.href = element.href;
      }
    })
    .end();

  setTimeout(() => {
    dialog.addClass('visible');
  }, 10);

  return false;
};

$.alert = (message) => {
  $.confirm(null, message, true);
};

$.progressWheel = () => {
  $.dim();
  // TODO: check if this is needed, else remove
};
